import { FC, Fragment } from "react";
// Redux
import { useAppSelector } from "hooks/useStore";
import { selectAdditionalQuestions } from "store/quiz/quizzesSelectors";
import IQuestion from "models/Question";
// Components
import QuestionItem from "./QuestionItem";
import { Message } from "components/Utilities";
// i18next
import { useTranslation } from "react-i18next";

const AdditionalQuestionsList:FC = () => {
  const { t } = useTranslation();

  const additionalQuestions = useAppSelector(selectAdditionalQuestions);

  if (!additionalQuestions.length) return (
    <Message text={t('pages.answersAnalytics.noAdditionalQuestionsData')} />
  )
  return (
    <Fragment>
      {additionalQuestions.map((question:IQuestion, questionIndex:number) => (
        <QuestionItem key={question.ref} question={question} questionIndex={questionIndex} />
      ))}
    </Fragment>
  );
}

export default AdditionalQuestionsList;